const replaceHyphenWithSpace = (inputString) => {
    return inputString.replace(/-/g, ' ');
}

export default replaceHyphenWithSpace;